export const SEARCH_MULTI_REQUEST = 'search/MULTI_REQUEST';
export const SEARCH_MULTI_SUCCESS = 'search/MULTI_SUCCESS';
export const SEARCH_MULTI_FAILURE = 'search/MULTI_FAILURE';
export const SEARCH_CLEAR = 'search/CLEAR';
